// extracted by mini-css-extract-plugin
module.exports = {"text":"Title_text__3e55y","spin":"Title_spin__BN-Xi","transition-opacity":"Title_transition-opacity__6Wa9F"};